import { Component, OnInit, Input } from '@angular/core';
import { PendingHorseShowEntryService } from '../../providers/pending-horse-show-entry.service';
import { EntryTypeService } from '../../providers/entry-type.service';
import { HorseShowService } from '../../providers/horse-show.service';
import { WaiverService } from '../../providers/waiver.service';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import { Entry_type } from '../../models/entry_type';
import { Horse_show } from '../../models/horse_show';
import { Horse_show_entry } from '../../models/horse_show_entry';
import { Horse } from '../../models/horse';
import { Person } from '../../models/person';
import { Signature } from '../../models/signature';
import { Waiver } from '../../models/waiver';
import { faPrint } from '@fortawesome/pro-regular-svg-icons';

import * as dayjs from 'dayjs';

@Component({
  standalone: false,
  selector: 'app-view-entry-form',
  templateUrl: './view-entry-form.component.html',
styleUrls:  ['./view-entry-form.component.css']
})
export class ViewEntryFormComponent extends SmsAbstractAppPage implements OnInit {

	@Input() entry_id: string;
	waiver_text: string = '';
	horse_show: Horse_show = new Horse_show({});
	horse_show_entry: Horse_show_entry = new Horse_show_entry({});
	signature_list_even: Signature[] = [];
	signature_list_odd: Signature[] = [];
  entry_type: Entry_type = new Entry_type({});
  faPrint = faPrint;

  constructor(private pendingHorseShowEntryService:PendingHorseShowEntryService,
  	private horseShowService: HorseShowService,
    private entryTypeService: EntryTypeService,
  	private waiverService:WaiverService) {
  	super();
  }

  ngOnInit() {

  	//Get horse show entry
  	this.pendingHorseShowEntryService.get(this.entry_id).then(horse_show_entry => {

  		this.horse_show_entry = horse_show_entry;
		//Divide signatures into odd and even lists
		this.doArrangeSignatures(horse_show_entry.signature_list);

		//Get horse show
  		this.horseShowService.get(horse_show_entry.horse_show_id).then(horse_show => {
  			this.horse_show = horse_show;

        this.entryTypeService.get(horse_show_entry.horse_show_id, horse_show_entry.entry_type).then(entry_type => {
          this.entry_type = entry_type;
        }).catch(error => {
          this.handleError(error);
        });

  			//Get waiver
			this.waiverService.get(horse_show.waiver_id).then(waiver =>{
				this.waiver_text = waiver.waiver_text;
			}).catch(error => {
				this.handleError(error);
			});
  		}).catch(error => {
  			this.handleError(error);
  		});

  	}).catch(error => {
  		this.handleError(error);
  	});

  }

  private doArrangeSignatures(signature_list: Signature[]){
  	signature_list.forEach((signature, i) => {
  		if(signature.document_type == 'HORSE SHOW ENTRY'){
	  		if(i % 2 == 0){
	  			this.signature_list_even.push(signature);
	  		} else {
	  			this.signature_list_odd.push(signature);
	  		}
  		}
  	});
  }

}
